module.exports = __webpack_public_path__ + "static/media/background.0ba80a10.png";